import { type MCPServerInfo } from '../../types';

const UpwindServer: MCPServerInfo = {
  serverId: 'UPWIND',
  name: 'Upwind',
  slug: 'upwind',
  description:
    "Upwind's official remote MCP server for runtime cloud security — query findings, investigate incidents, and surface asset context across your cloud workloads.",
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.upwind.io/mcp'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
};

export default UpwindServer;
